// src/js/index.ts
import { requireNotNull } from "@enymo/ts-nullsafe";
import React, { useContext } from "react";
function createContext(defaultValue) {
  const Context = React.createContext(defaultValue);
  return [Context.Provider, () => useContext(Context)];
}
function createRequiredContext(reason) {
  const Context = React.createContext(null);
  return [Context.Provider, () => requireNotNull(useContext(Context), reason)];
}
export {
  createContext,
  createRequiredContext
};
